<template>
    <div class="p-4">
        <!-- Lista extrase existente -->
        <div class="border rounded p-3 mb-3 bg-light">
            <div class="d-flex justify-content-between align-items-center mb-3">
                <h5 class="mb-0">Extrase introduse</h5>
                <button
                    type="button"
                    class="btn btn-sm btn-success"
                    @click="openForm"
                >
                    Adaugă extras
                </button>
            </div>

            <div v-if="loadingList" class="text-center py-3">
                <span class="spinner-border spinner-border-sm"></span>
            </div>
            <div v-else>
                <div v-if="existingExtrase.length">
                    <ul class="list-unstyled mb-0">
                        <li
                            v-for="item in existingExtrase"
                            :key="item.id"
                            class="mb-2"
                        >
                            <div class="d-flex justify-content-between align-items-center">
                                <div>
                                    <strong>{{ item.banca || '—' }}</strong>
                                    —
                                    {{ item.data_start }} - {{ item.data_end }}
                                </div>
                                <button
                                    type="button"
                                    class="btn btn-xs btn-success"
                                    @click="toggleExtras(item.id)"
                                    :title="expandedExtrasId === item.id ? 'Ascunde detaliile' : 'Vezi / adaugă linii extras'"
                                >
                                    <i class="fa-solid" :class="expandedExtrasId === item.id ? 'fa-minus' : 'fa-plus'"></i>
                                </button>
                            </div>

                            <div
                                v-if="expandedExtrasId === item.id"
                                class="mt-2 ms-3"
                            >
                                <!-- Tabel linii existente -->
                                <div v-if="tranzactiiByExtras[item.id] && tranzactiiByExtras[item.id].length">
                                    <div class="table-responsive">
                                        <table class="table table-sm table-bordered mb-2">
                                            <thead class="table-light">
                                                <tr>
                                                    <th style="width: 110px;">Data</th>
                                                    <th>Descriere</th>
                                                    <th style="width: 100px;">Tip</th>
                                                    <th style="width: 120px;">Cont D</th>
                                                    <th style="width: 120px;">Cont C</th>
                                                    <th style="width: 120px;">Suma D</th>
                                                    <th style="width: 120px;">Suma C</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="t in tranzactiiByExtras[item.id]" :key="t.id">
                                                    <td>{{ t.data_tranzactie }}</td>
                                                    <td>{{ t.explicatie }}</td>
                                                    <td>{{ t.tip_tranzactie }}</td>
                                                    <td>{{ t.cont_debit }}</td>
                                                    <td>{{ t.cont_credit }}</td>
                                                    <td>{{ t.suma_debit }}</td>
                                                    <td>{{ t.suma_credit }}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div v-else class="text-muted small mb-2">
                                    Nu există încă linii pentru acest extras.
                                </div>

                                <!-- Formular adăugare linie nouă -->
                                <div class="card card-body p-2">
                                    <div class="row g-2">

                                        <!-- Data + Tip tranzacție (same row) -->
                                        <div class="col-md-6">
                                            <label class="form-label form-label-sm mb-1">Data</label>
                                            <div class="input-group input-group-sm">
                                                <input
                                                    type="date"
                                                    class="form-control form-control-sm"
                                                    v-model="newLine.data_tranzactie"
                                                    ref="data_tranzactie"
                                                />
                                                <button
                                                    type="button"
                                                    class="date-picker-btn btn btn-outline-secondary btn-sm"
                                                    @click="openNativePicker('data_tranzactie')"
                                                    aria-label="Deschide calendar"
                                                >
                                                    📅
                                                </button>
                                            </div>
                                        </div>

                                        <div class="col-md-6">
                                            <label class="form-label form-label-sm mb-1">Tip tranzacție</label>
                                            <input
                                                type="text"
                                                class="form-control form-control-sm"
                                                v-model="newLine.tip_tranzactie"
                                            />
                                        </div>

                                        <!-- Repeater linii contabile -->
                                        <div class="col-12">
                                            <div class="d-flex align-items-center justify-content-between mb-1">
                                                <label class="form-label form-label-sm fw-bold mb-0">Linii contabile</label>
                                                <button
                                                    type="button"
                                                    class="btn btn-light-primary btn-sm"
                                                    @click="liniiRJ.push({ cont_debit: '', cont_credit: '', suma: 0, explicatie: '' })"
                                                >
                                                    <i class="fa-solid fa-plus"></i> Adaugă linie
                                                </button>
                                            </div>

                                            <table class="table table-sm table-bordered align-middle mb-2">
                                                <thead>
                                                    <tr>
                                                        <th>Debit</th>
                                                        <th>Credit</th>
                                                        <th style="width:160px" class="text-end">Sumă</th>
                                                        <th>Explicație</th>
                                                        <th style="width:48px"></th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="(linie, idx) in liniiRJ" :key="`rj_${item.id}_${idx}`">
                                                        <td>
                                                            <input
                                                                type="text"
                                                                class="form-control form-control-sm"
                                                                v-model="linie.cont_debit"
                                                                placeholder="ex: 5121.01"
                                                            />
                                                        </td>
                                                        <td>
                                                            <input
                                                                type="text"
                                                                class="form-control form-control-sm"
                                                                v-model="linie.cont_credit"
                                                                placeholder="ex: 4111 sau 758"
                                                            />
                                                        </td>
                                                        <td>
                                                            <input
                                                                type="number"
                                                                step="0.01"
                                                                class="form-control form-control-sm text-end"
                                                                v-model.number="linie.suma"
                                                            />
                                                        </td>
                                                        <td>
                                                            <input
                                                                type="text"
                                                                class="form-control form-control-sm"
                                                                v-model="linie.explicatie"
                                                                placeholder="Explicație"
                                                            />
                                                        </td>
                                                        <td class="text-center">
                                                            <button
                                                                type="button"
                                                                class="btn btn-sm btn-light-danger"
                                                                @click="liniiRJ.splice(idx, 1)"
                                                            >
                                                                <i class="fa-solid fa-trash"></i>
                                                            </button>
                                                        </td>
                                                    </tr>
                                                    <tr v-if="!liniiRJ.length">
                                                        <td colspan="5" class="text-center text-muted small py-2">
                                                            Apasă „Adaugă linie” pentru a introduce linii contabile.
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>

                                            <small class="text-muted">
                                                Sfat: asigură-te că totalul debitelor = totalul creditelor.
                                            </small>
                                        </div>

                                        <div class="col-md-12 text-end mt-2">
                                            <button
                                                type="button"
                                                class="btn btn-sm btn-primary"
                                                :disabled="savingLine"
                                                @click="addLinie(item.id)"
                                            >
                                                <span
                                                    v-if="savingLine"
                                                    class="spinner-border spinner-border-sm me-1"
                                                ></span>
                                                Adaugă
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
                <div v-else class="text-muted">
                    Nu există extrase pentru acest fișier.
                </div>
            </div>

        </div>

        <!-- Formular de introducere extras (opțional, doar când se apasă butonul) -->
        <div
            v-if="showForm"
            class="border rounded p-3 mb-3 bg-light"
        >
            <div
                v-if="showForm"
                class="d-flex justify-content-between align-items-center mb-3"
            >
                <h5 class="mb-0">Extras bancar nou</h5>

                <button
                    type="button"
                    class="btn btn-sm btn-light border"
                    @click="showForm = false"
                    title="Anulează"
                >
                    <i class="fa-solid fa-xmark"></i>
                </button>
            </div>

            <div class="row g-2">
                <div class="col-md-6">
                    <label class="form-label">Banca</label>
                    <input
                        type="text"
                        class="form-control form-control-sm"
                        v-model="extras.banca"
                    />
                </div>

                <div class="col-md-6">
                    <label class="form-label">IBAN</label>
                    <input
                        type="text"
                        class="form-control form-control-sm"
                        v-model="extras.iban"
                    />
                </div>

                <div class="col-md-6">
                    <label class="form-label">Monedă</label>
                    <input
                        type="text"
                        class="form-control form-control-sm"
                        v-model="extras.moneda"
                        placeholder="RON"
                    />
                </div>

                <div class="col-md-6">
                    <label class="form-label">Lună</label>
                    <div class="input-group input-group-sm">
                        <input
                            type="month"
                            class="form-control form-control-sm"
                            v-model="extras.luna"
                            ref="luna"
                        />
                        <button
                            type="button"
                            class="date-picker-btn btn btn-outline-secondary btn-sm"
                            @click="openNativePicker('luna')"
                            aria-label="Deschide selector lună"
                        >
                            📅
                        </button>
                    </div>
                </div>

                <div class="col-md-6">
                    <label class="form-label">Sold inițial</label>
                    <input
                        type="number"
                        step="0.01"
                        class="form-control form-control-sm"
                        v-model="extras.sold_initial"
                    />
                </div>

                <div class="col-md-6">
                    <label class="form-label">Sold final</label>
                    <input
                        type="number"
                        step="0.01"
                        class="form-control form-control-sm"
                        v-model="extras.sold_final"
                    />
                </div>
            </div>
        </div>

        <!-- Mesaje -->
        <div v-if="error" class="alert alert-danger py-2">
            {{ error }}
        </div>
        <div v-if="success" class="alert alert-success py-2">
            {{ success }}
        </div>

        <!-- Buton salvare -->
        <div
            v-if="showForm"
            class="d-flex justify-content-end mt-3"
        >
            <button
                type="button"
                class="btn btn-success"
                :disabled="saving || !canSave"
                @click="saveExtrase"
            >
                <span v-if="saving" class="spinner-border spinner-border-sm me-2"></span>
                Salvează extrasele
            </button>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ExtraseProcesare',

    props: {
        firmaId: { type: Number, required: true },
        fisierId: { type: Number, required: false },
    },

    data() {
        return {
            extras: new Form({
                banca: '',
                iban: '',
                moneda: 'RON',
                luna: '',
                data_start: '',
                data_end: '',
                sold_initial: '',
                sold_final: '',
            }),
            existingExtrase: [],
            loadingList: false,
            showForm: false,
            saving: false,
            savingLine: false,
            expandedExtrasId: null,
            tranzactiiByExtras: {},
            newLine: new Form({
                data_tranzactie: '',
                tip_tranzactie: '',
            }),
            liniiRJ: [],
            // v-form instances for POST requests
            formExtras: new Form({
                id_firma: null,
                id_fisier: null,
                extrase: [],
            }),
            lineForm: new Form({
                extras_id: null,
                data_tranzactie: '',
                descriere: '',
                suma_debit: '',
                suma_credit: '',
            }),
            error: null,
            success: null,
        };
    },

    mounted() {
        this.loadExistingExtrase()
    },

    computed: {
        canSave() {
            // Poți relaxa regulile, dar minim să existe o perioadă definită
            return this.extras && this.firmaId > 0;
        },
    },

    methods: {
        openNativePicker(refName) {
            const input = this.$refs[refName]
            if (!input) return

            // Dacă este un array de referințe (în cazul v-for), luăm primul element
            const el = Array.isArray(input) ? input[0] : input

            if (el && typeof el.showPicker === 'function') {
                el.showPicker()
            } else if (el) {
                el.focus()
                el.click()
            }
        },
        async loadExistingExtrase() {
            this.loadingList = true
            this.error = null

            try {
                const res = await axios.get('/api/administrare/work/extrase/list', {
                    params: { firma_id: this.firmaId }
                })

                const all = res.data?.extrase || []
                this.existingExtrase = all.filter(e => {
                    if (!this.fisierId) return true
                    return e.id_fisier === this.fisierId
                })
            } catch (e) {
                console.error(e)
                this.error = 'Nu s-au putut încărca extrasele existente.'
            }

            this.loadingList = false
        },

        openForm() {
            this.showForm = true
            this.error = null
            this.success = null
            this.extras.reset();
        },

        async loadTranzactii(extrasId) {
            try {
                const res = await axios.get('/api/administrare/work/extrase/detalii', {
                    params: { extras_id: extrasId },
                })
                this.tranzactiiByExtras = {
                    ...this.tranzactiiByExtras,
                    [extrasId]: res.data?.tranzactii || [],
                }
            } catch (e) {
                console.error(e)
                this.error = 'Nu s-au putut încărca liniile extrasului.'
            }
        },

        async toggleExtras(extrasId) {
            if (this.expandedExtrasId === extrasId) {
                this.expandedExtrasId = null
                return
            }

            this.expandedExtrasId = extrasId
            this.error = null
            this.success = null

            if (this.newLine && typeof this.newLine.reset === 'function') {
                this.newLine.reset()
            }
            this.liniiRJ = []

            if (!this.tranzactiiByExtras[extrasId]) {
                await this.loadTranzactii(extrasId)
            }
        },

        async addLinie(extrasId) {
            this.error = null
            this.success = null
            this.savingLine = true

            if (!this.liniiRJ.length) {
                this.error = 'Adaugă cel puțin o linie contabilă.'
                this.savingLine = false
                return
            }

            try {
                for (const linie of this.liniiRJ) {
                    this.lineForm = new Form({
                        extras_id: extrasId,
                        data_tranzactie: this.newLine.data_tranzactie || null,
                        explicatie: linie.explicatie || null,
                        suma_debit: linie.suma || null,
                        suma_credit: linie.suma || null,
                        tip_tranzactie: this.newLine.tip_tranzactie || null,
                        cont_debit: linie.cont_debit || null,
                        cont_credit: linie.cont_credit || null,
                    })

                    const res = await this.lineForm.post('/api/administrare/work/extrase/adauga-linie')
                    const linieResp = res.data?.linie || res.data?.tranzactie || null

                    if (window.Swal && res.data?.status === 'success') {
                        window.Swal.fire({
                            position: 'top-end',
                            toast: true,
                            showConfirmButton: false,
                            timer: 2500,
                            timerProgressBar: true,
                            icon: 'success',
                            title: 'Succes',
                            text: res.data.message || 'Linia a fost adăugată.',
                        })
                    } else if (res.data?.message) {
                        this.success = res.data.message
                    }

                    if (linieResp) {
                        const current = this.tranzactiiByExtras[extrasId] || []
                        this.tranzactiiByExtras = {
                            ...this.tranzactiiByExtras,
                            [extrasId]: [...current, linieResp],
                        }
                    } else {
                        await this.loadTranzactii(extrasId)
                    }
                }

                // după ce am trimis toate liniile, resetăm repeaterul
                this.liniiRJ = []
            } catch (e) {
                console.error(e)
                const msg = e?.response?.data?.error || 'Nu s-au putut adăuga liniile.'
                if (window.Swal) {
                    window.Swal.fire({
                        position: 'top-end',
                        toast: true,
                        showConfirmButton: false,
                        timer: 2500,
                        timerProgressBar: true,
                        icon: 'error',
                        title: 'Eroare',
                        text: msg,
                    })
                } else {
                    this.error = msg
                }
            }

            this.savingLine = false
        },

        async saveExtrase() {
            this.error = null
            this.success = null
            this.saving = true

            // pregătim formularul v-form pentru extras
            this.formExtras = new Form({
                id_firma: this.firmaId,
                id_fisier: this.fisierId || null,
                extrase: [this.extras],
            })

            try {
                const res = await this.formExtras.post('/api/administrare/work/extrase/store')

                // toast de succes
                if (window.Swal) {
                    window.Swal.fire({
                        position: 'top-end',
                        toast: true,
                        showConfirmButton: false,
                        timer: 2500,
                        timerProgressBar: true,
                        icon: 'success',
                        title: 'Succes',
                        text: res.data?.message || 'Extrasul a fost salvat.',
                    })
                } else {
                    this.success = res.data?.message || 'Extrasul a fost salvat.'
                }

                // Reîncarcă lista de extrase pentru acest fișier
                await this.loadExistingExtrase()
                this.showForm = false
                this.$emit('updated')
            } catch (e) {
                console.error(e)
                const msg = e?.response?.data?.error || 'A apărut o eroare la salvare.'
                if (window.Swal) {
                    window.Swal.fire({
                        position: 'top-end',
                        toast: true,
                        showConfirmButton: false,
                        timer: 2500,
                        timerProgressBar: true,
                        icon: 'error',
                        title: 'Eroare',
                        text: msg,
                    })
                } else {
                    this.error = msg
                }
            }

            this.saving = false
        },
    },
};
</script>

<style scoped>
</style>